import { YOO_FINDS_CDN } from "@/common";

export const TICKETS_BANNER = `${YOO_FINDS_CDN}/pc/personal-center/tickets/tickets-banner.webp`;
export const TICKETS_FOOTER = `${YOO_FINDS_CDN}/pc/personal-center/tickets/tickets-footer.webp`;

export const LA_TICKETS_BANNER = `${YOO_FINDS_CDN}/pc/personal-center/tickets/center-la-tickets-banner.webp`;
export const LA_TICKETS_FOOTER = `${YOO_FINDS_CDN}/pc/personal-center/tickets/la-tickets-footer.webp`;

export const LA_TICKETS_TREE = `${YOO_FINDS_CDN}/pc/personal-center/tickets/tree.webp`;
